import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import HomepagePackageBlockData from 'Models/Content/HomepagePackageBlockData';
import {getTextWithHighlight} from 'app/utilities/highlightText';
import MarketingTextBlockData from 'Models/Content/MarketingTextBlockData';
import {useInView} from 'react-intersection-observer';
import {getImageProps} from 'app/utilities/ImageProps';
import classNames from 'classnames';
import TagName from 'app/Components/Shared/TagName';

const HomepagePackageBlock = ({data, context}: ComponentProps<HomepagePackageBlockData>) => {
  const [isIn, setIsIn] = useState(false);

  const {ref, inView} = useInView({
    threshold: 0.5,
    triggerOnce: true,
  });

  useEffect(() => {
    if (inView) setIsIn(true);
  }, [inView]);

  return (
    <div ref={ref} className='HomepagePackageBlock'>
      <div className={classNames('HomepagePackageBlock__wrap', {'slide-in': isIn, reverse: !data.alignToRIght?.value})}>
        <div className='HomepagePackageBlock__content'>
          {data.title?.expandedValue.map(({text, highlightText}: MarketingTextBlockData, i: number) => (
            <TagName className='HomepagePackageBlock__content__title' tagName={data.titleHeadlineTag?.value} isTitle key={i}>
              {getTextWithHighlight({text: text?.value, highlightText: highlightText?.value})}
            </TagName>
          ))}
          <TagName tagName={data.subTitleHeadlineTag?.value} className='HomepagePackageBlock__content__subtitle'>
            {data.blockSubtitle?.value}
          </TagName>
          <p className='HomepagePackageBlock__content__text'>{data.description?.value}</p>
          <ul className='HomepagePackageBlock__content__benefits'>
            {data.benefits?.expandedValue?.map(({text}: MarketingTextBlockData, i: number) => (
              <li key={i}>{text?.value}</li>
            ))}
          </ul>
          <div className='HomepagePackageBlock__content__prices'>
            {data.price && data.price?.value && (
              <>
                <span className='HomepagePackageBlock__content__prices__prePrice'>{data.prePriceText?.value}</span>

                <span className='HomepagePackageBlock__content__prices__price'>
                  <span className='HomepagePackageBlock__content__prices__price__value'>
                    {data.price?.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  </span>
                  <span className='HomepagePackageBlock__content__prices__price__ils'>₪</span>
                </span>

                <span className='HomepagePackageBlock__content__prices__afterPrice'>
                  {data.fullPrice && data.fullPrice?.value > 0 && (
                    <span className='HomepagePackageBlock__content__prices__afterPrice__full-price'>₪{data.fullPrice?.value}</span>
                  )}
                  {data.afterPriceText?.value}
                </span>
              </>
            )}
          </div>
          {data.buttonLink?.value && (
            <a className='HomepagePackageBlock__content__button' href={data.buttonLink?.value}>
              {data.buttonLinkTitle?.value}
            </a>
          )}
        </div>
        <div className='HomepagePackageBlock__image_wrapper' style={{ backgroundColor: 'transparent !important' }}>
          <Image className='HomepagePackageBlock__image' {...getImageProps(data.image, context)} />
        </div>
      </div>
    </div>
  );
};

export default HomepagePackageBlock;
